class LiveAuctionTimeService {
  getStaleTime (ms) {
    let s = Math.floor(ms / 1000)
    let m = Math.floor(ms / 60 / 1000)
    let h = Math.floor(ms / 60 / 60 / 1000)
    return { hours: h, minutes: m - 60 * h, seconds: s - 60 * m, done: false }
  }

  getTime (offsetMsFromProps) {
    const offsetMs = offsetMsFromProps || this.offsetMs
    let clientTime = new Date()
    return clientTime.valueOf() + offsetMs
  }

  getTimeTo (date, { mode = 'until', compareWith } = {}, offsetMsFromProps) {
    date = new Date(date).getTime()
    compareWith = compareWith === undefined || null ? this.getTime(offsetMsFromProps) : new Date(compareWith).getTime()
    let ms
    switch (mode) {
      case 'until':
        ms = date - compareWith
        break
      case 'after':
        ms = compareWith - date
        break
      default:
        throw new Error('Unknown mode')
    }
    if (ms < 0) {
      return { hours: 0, minutes: 0, seconds: 0, done: true }
    }
    let s = Math.floor(ms / 1000)
    let m = Math.floor(ms / 60 / 1000)
    let h = Math.floor(ms / 60 / 60 / 1000)
    let obj = { hours: h, minutes: m - 60 * h, seconds: s - 60 * m, done: false }
    return obj
  }

  getLotTimeLeft (lot, offsetMsFromProps) {
    return lot.staleTime
      ? this.getStaleTime(lot.staleTime)
      : this.getTimeTo(lot.finishAt, { mode: 'until' }, offsetMsFromProps)
  }

  getAuctionTimeLeft (auction, offsetMsFromProps) {
   let  compareWith = auction.staleTime === undefined  || null ? this.getTime(offsetMsFromProps) : new Date(auction.staleTime).getTime()
   let finishAtt = new Date(auction.finishAt || 0).valueOf()
    return auction.staleTime
      ? this.getStaleTime(finishAtt - compareWith)
      : this.getTimeTo(auction.finishAt, { mode: 'until' }, offsetMsFromProps)
  }
}

export default new LiveAuctionTimeService()
